import { render, staticRenderFns } from "./ViewDescription.vue?vue&type=template&id=c88df84a&"
import script from "./ViewDescription.vue?vue&type=script&lang=js&"
export * from "./ViewDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports